/**
 * TypeScript types for Clinical Notes
 * Matches backend ClinicalNoteDTO
 */

export enum ClinicalNoteType {
  PROGRESS = 'PROGRESS',
  NURSE = 'NURSE',
  SOCIAL_WORK = 'SOCIAL_WORK',
  SPIRITUAL_CARE = 'SPIRITUAL_CARE',
  PHYSICIAN = 'PHYSICIAN',
}

export interface ClinicalNoteDTO {
  id?: string;
  residentId: string;
  noteType: ClinicalNoteType;
  subject: string;
  content: string;
  noteDate: string; // ISO DateTime
  authorId?: string;
  authorName?: string;
  authorRole?: string;
  isConfidential?: boolean;
  isSigned?: boolean;
  signedAt?: string; // ISO DateTime
  signedBy?: string;
  attachments?: string;
  tags?: string;
  tenantId?: string;
  facilityId?: string;
  createdAt?: string;
  updatedAt?: string;
  residentName?: string; // Computed
}

export interface CreateClinicalNoteRequest {
  residentId: string;
  noteType: ClinicalNoteType;
  subject: string;
  content: string;
  noteDate: string;
  isConfidential?: boolean;
  attachments?: string;
  tags?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}